// Copyright (c) StrangeBee 2024

import React, { ReactNode, ReactElement } from 'react';

import './Footer.scss';

interface FooterProps {
    children?: ReactNode;
    actions?: ReactNode;
}

export const Footer = ({ children, actions }: FooterProps): ReactElement => (
    <div className="th-drawer__footer">
        <div className="th-drawer__actions">{actions}</div>
        <div className="th-drawer__navigation"> {children}</div>
    </div>
);
